module.exports = __webpack_public_path__ + "static/media/workshop3.22414789.jpg";